/**
   * Given a data as an input, return a boolean
   * Check whether input is an Array
   * Example
   * ===========================
   * isArray(["arr"]) => true
   * ===========================
   * @param {any} data
   * @return {boolean}
   */

   const isArray = (data) => Object.prototype.toString.call(data) === "[object Array]";

  export default isArray;
